import { ActionContext } from 'vuex';

import { getLocalState } from '@/common/utils/store';

import { TDashboardCountryTopRfSubjectsFilterPayload } from '../../types/countryDashboards';
import { TDashboardCountryFilterPayload } from '../../types/countryDashboards';
import { COUNTRY_DASHBOARDS_VES_ACTIONS_NAME, COUNTRY_DASHBOARDS_VES_MUTATIONS_NAME } from './name';
import { TRegionDashboardStoreState } from './types';

import links from '@/utils/links';
import request from '@/utils/request';

export async function getIndicatorCards(
  context: ActionContext<TRegionDashboardStoreState, unknown>,
  payload: TDashboardCountryFilterPayload,
) {
  return request(
    context,
    {
      url: links.ves.dashboards.getRegionStatistic,
      mutate: getLocalState(COUNTRY_DASHBOARDS_VES_MUTATIONS_NAME.setIndicatorCards),
      name: getLocalState(COUNTRY_DASHBOARDS_VES_ACTIONS_NAME.getIndicatorCards),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getPersonInfo(
  context: ActionContext<TRegionDashboardStoreState, unknown>,
  payload: TDashboardCountryFilterPayload,
) {
  return request(
    context,
    {
      url: links.ves.dashboards.getPersonInfo,
      mutate: getLocalState(COUNTRY_DASHBOARDS_VES_MUTATIONS_NAME.setPersonInfo),
      name: getLocalState(COUNTRY_DASHBOARDS_VES_ACTIONS_NAME.getPersonInfo),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getTopRfSubjectsEvents(
  context: ActionContext<TRegionDashboardStoreState, unknown>,
  payload: TDashboardCountryTopRfSubjectsFilterPayload,
) {
  return request(
    context,
    {
      url: links.ves.dashboards.getTopRfSubjectsEvents,
      mutate: getLocalState(COUNTRY_DASHBOARDS_VES_MUTATIONS_NAME.setTopRfSubjectsEvents),
      name: getLocalState(COUNTRY_DASHBOARDS_VES_ACTIONS_NAME.getTopRfSubjectsEvents),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export async function getTopRfSubjectsGrowthRate(
  context: ActionContext<TRegionDashboardStoreState, unknown>,
  payload: TDashboardCountryTopRfSubjectsFilterPayload,
) {
  return request(
    context,
    {
      url: links.ves.dashboards.getTopRfSubjectsGrowthRate,
      mutate: getLocalState(COUNTRY_DASHBOARDS_VES_MUTATIONS_NAME.setTopRfSubjectsGrowthRate),
      name: getLocalState(COUNTRY_DASHBOARDS_VES_ACTIONS_NAME.getTopRfSubjectsGrowthRate),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export function getEventsCountByTypes(
  context: ActionContext<TRegionDashboardStoreState, unknown>,
  payload: TDashboardCountryFilterPayload,
) {
  return request(
    context,
    {
      url: links.ves.dashboards.getEventsCountByTypes,
      mutate: getLocalState(COUNTRY_DASHBOARDS_VES_MUTATIONS_NAME.setEventsCountByTypes),
      name: getLocalState(COUNTRY_DASHBOARDS_VES_ACTIONS_NAME.getEventsCountByTypes),
      abortController: payload.abortController,
    },
    payload.params,
  );
}

export function getAgreementsCountByTypes(
  context: ActionContext<TRegionDashboardStoreState, unknown>,
  payload: TDashboardCountryFilterPayload,
) {
  return request(
    context,
    {
      url: links.ves.dashboards.getAgreementsCountByTypes,
      mutate: getLocalState(COUNTRY_DASHBOARDS_VES_MUTATIONS_NAME.setAgreementsCountByTypes),
      name: getLocalState(COUNTRY_DASHBOARDS_VES_ACTIONS_NAME.getAgreementsCountByTypes),
      abortController: payload.abortController,
    },
    payload.params,
  );
}
